import type { PhoneNumber } from "@sales-ops-amplify/shared";
import { apiGet, apiPost } from "./client";

export function listPhoneNumbers(): Promise<{
  numbers: PhoneNumber[];
  twilioConfigured: boolean;
}> {
  return apiGet("/api/phone-numbers");
}

export function syncTwilioPhoneNumbers(): Promise<{ numbers: PhoneNumber[] }> {
  return apiPost("/api/phone-numbers/sync-twilio", {});
}

export function setDefaultPhoneNumber(
  phoneNumberId: string,
): Promise<{ number: PhoneNumber }> {
  return apiPost(`/api/phone-numbers/${phoneNumberId}/default`, {});
}

export function searchTwilioNumbers(body: {
  country?: string;
  areaCode?: string;
}): Promise<{
  results: Array<{ e164: string; friendlyName?: string; region?: string }>;
}> {
  return apiPost("/api/phone-numbers/search", body);
}

export function purchaseTwilioNumber(
  e164: string,
): Promise<{ number: PhoneNumber }> {
  return apiPost("/api/phone-numbers/purchase", { e164 });
}
